
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

import React, { Fragment as F, useEffect, useState } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import {
  Link,
  BrowserRouter as Router,
  Route,
  Routes,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom"
import Select from 'react-select'



import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';




import {
  C,
  logg,
  useApiRouter,
  appRouter,
} from "$shared"

/**
 * FintechsIndex
**/
const FintechsIndex = (props) => {
  // logg(props, 'FintechsIndex')

  const apiRouter = useApiRouter()

  const [ fintechs, setFintechs ] = useState([])
  const [ filteredFintechs, setFilteredFintechs ] = useState([])
  const [ subfunctions, setSubfunctions ] = useState([])
  // const [ selectedSubfunctions, selectSubfunctions ] = useState([])

  const selectSubfunctions = (props) => {
    logg(props, 'selectSubfunctions')

    let filteredFintechs = fintechs
    logg(filteredFintechs, 'filteredFintechs 1')
    const subfunctionIds = props.map((inn) => inn.value)
    subfunctionIds.forEach((id, idx) => {
      filteredFintechs = filteredFintechs.filter((fintech) =>
        fintech.subfunction_ids.indexOf(id) != -1
      );
      logg(filteredFintechs, 'filteredFintechs 2')
    })
    logg(filteredFintechs, 'filteredFintechs 3')
    setFilteredFintechs(filteredFintechs)

  }

  useEffect(() => {
    fetch(apiRouter.fintechsPath()).then((r) => r.json()).then((inns) => {
      logg(inns, 'fintechsData')
      setFintechs(inns)
      setFilteredFintechs(inns)
    })
  }, [])

  useEffect(() => {
    fetch(apiRouter.subfunctionsPath()).then((r) => r.json()).then((_inns) => {
      // logg(_inns, 'subfunctionsData')
      const inns = _inns.map((inn) => ({ label: inn.name, value: inn.id }) )
      logg(inns, 'inns2')
      setSubfunctions(inns)
    })
  }, [])

  return <F>
    <h1>Fintechs Index</h1>
    <TextField id="outlined-basic" label="Search" variant="outlined"
      style={{
        display: 'flex',
        flexGrow: 1,
        margin: '0 5em 1em',
      }}
    />
    <div style={{ display: "flex", margin: "0 5em 1em" }}>
      <TextField id="outlined-basic" label="Category Filter" variant="outlined"
        style={{
          display: 'flex',
          flexGrow: 1,
        }}
      />

      <InputLabel className='select2-label' >Functions:</InputLabel>
      <Select
        className='select2'
        classNamePrefix="rs2"
        isMulti
        name="Functions"
        options={subfunctions}
        onChange={selectSubfunctions}
        styles={C.select2Styles}
      />
    </div>

    <Grid container spacing={2}>
      { filteredFintechs.map((fintech) => {
        return <Grid item xs={6} md={3} >
          <Link to={appRouter.fintechPath(fintech.id)} >
            <Card variant="outlined">
              <CardContent>
                [img]
                <Typography variant="h5" component="div">
                  {fintech.name}
                </Typography>
              </CardContent>
            </Card>
          </Link>

        </Grid>
      }) }
    </Grid>
  </F>
}

export default FintechsIndex
